import { useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'components/UI/Link/Link';
import { RemoveMembershipPrompt } from 'components/Cart/Prompts/RemoveMembershipPrompt';
import { toAudString } from 'utils/currency';

export const MembershipsSummary = (props) => {
  const { membershipItems, allowRemove, stepName, redeemedGiftCertificates } = props;

  const [membershipItem, setMembershipItem] = useState(null);

  const handleRequestPromptClose = () => {
    setMembershipItem(null);
  };

  const requestRemoveMembership = (lineItemId, description) => {
    setMembershipItem({
      lineItemId,
      description,
    });
  };

  return (
    <>
      <RemoveMembershipPrompt
        active={!!membershipItem}
        membership={membershipItem}
        stepName={stepName}
        onRequestClose={handleRequestPromptClose}
      />

      <hr />

      <span className="info-label">Membership</span>

      {membershipItems.map(({ LineItemId, CartDescription, Amount }) => (
        <div className="row" key={LineItemId} data-testid="membership-item">
          <div className="col-xs-8">{CartDescription}</div>
          <div className="col-xs-4 text-right">{toAudString(Amount)}</div>

          {redeemedGiftCertificates.length > 0 && allowRemove ? (
            <Link
              href="#"
              noUnderline
              onClick={() => requestRemoveMembership(LineItemId, CartDescription)}
              variant="secondary"
              extendClass="link-bold link-remove remove-membership ml-10"
            >
              Remove Membership
            </Link>
          ) : null}
        </div>
      ))}
    </>
  );
};

MembershipsSummary.propTypes = {
  membershipItems: PropTypes.array,
  allowRemove: PropTypes.bool,
  stepName: PropTypes.string,
  redeemedGiftCertificates: PropTypes.array,
};
